import styled from "styled-components";

export const MainSection = styled.div`
 padding: 0 50px;
  margin-top: 100px;

background: #FFFFFF;

  .section__content{
    background: #FFFFFF;
    margin-bottom: 200px;

       .section__header{
              text-align: center;
              margin-bottom: 30px;
        h2{
            font-weight: 700;
            font-size: 40px;
            line-height: 64px;
            color: #080055;
        } 
        p{
            font-weight: 400;
            font-size: 20px;
            line-height: 36px;
            text-align: center;
            /* width: 62%; */
            margin-left:auto;
            margin-right: auto;
            color: #696984;
        }
       }.section__header:hover{
         cursor: pointer;
               border: 0.125rem solid transparent;
                          }

/* end of section_header */
    /* grid */

       .section__grid{
           margin-top: 100px;
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            grid-auto-rows: 200px;
            /* minmax(100px, auto); */
            column-gap: 30px;
            row-gap: 200px;
            background: #FFFFFF;
          .section__gridList{
         
              .section__gridItem{
                  padding: 40px 10px;
                text-align: center;
                height: 340px;
                width: 90%;
                 background: #FFFFFF;
                box-shadow: 0px 10px 60px rgba(38, 45, 118, 0.08);
                border-radius: 20px;
                      
                          .section__img{
                          padding: 15px;
                          box-shadow: 0px 10px 40px rgba(54, 61, 136, 0.06);
                          width:80px;
                          height:80px;
                          border-radius:50px;
                          
                          } .section__img:hover{
                            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
                          }
                          .bg{
                            margin-left: auto;
                            margin-right: auto;
                            margin-bottom: 30px;
                            /* width: 30%; */
            
                          }

                          .one{
                            
                          background: #377DFF; 
                          }
                         
                          .two{
                          background: #FF6737;
                          }
                          .three{
                          background: #29B9E7;
                          padding:20px;

                          }
                          .four{
                          background: #F47F13;
                          padding:25px 5px;
                          }
                          .five{
                          background: #FF175D;

                          }
                          .six{
                          background: #F7C72A;

                          }
                          .seven{
                          background: #53E0FF;
                          padding:32px 12px;

                          }
                          .eight{
                          background: #09A896;
                          padding:23px 5px;

                          }
                          .nine{
                          background: #9113F4;

                          }
                          .ten{
                          background: #E72929;
                          padding:20px 5px;
                          }

                          }
                div{
                
                  h3{
                    font-weight: 600;
                    font-size: 24px;
                    line-height: 30px;
                    text-align: center;
                    color: #080055;
                  }
                  p{
                    font-size: 18px;
                    line-height: 32px;
                    text-align: center;
                    color: #5B5971;
                  }
                  }
                }
                
              } .section__gridItem:hover{
                            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
                          }

        }
        @media (min-width: 992px) {
          .section__content{
            min-width: 900px;
                .section__grid{
                  
                    .section__gridList{
                
                      .section__gridItem{
                      height: 380px;
                        div{
                          p{
                                    font-size: 15px;
                                    padding: 11px;
                                    line-height: 28px;
                                  }
                        }
                      }
                } 
              }
          }
                      }

   @media (max-width: 700px) {
    .section__header{
      text-align: center;
      flex-grow: 1;

    }
    .section__gridItem{
     height:auto;
  font-size: medium;
    }
   }
   @media (max-width:992px ) {
          min-width: 900px;
          .section__content{

            .section__grid{
              display: grid;
            grid-template-columns: 2fr 2fr;
            column-gap: 20px;

               .section__gridList{
                 .section__gridItem{

                 }
               }
            }
          }
   }
  
`